import api from './api';
import http from '../lib/http';
const PROTOBUF_JSON = 'application/x-protobuf-json';

const getBatchProductInfoByIds = (ids) => {
  return http.post(api.productInfoPath, {
    availonly: false,
    fields: ['price', 'colors', 'image'],
    ids: ids
  });
}

/**
 * 获取文章 json 数据
 */
const getArticleDetail = (articleId) => {
  return http.get(api.getArticleRes(articleId), {
    headers: {}
  });
}

const getProductsByIds = (ids) => {
  return http.post(api.discoverV3, {
    productIds: ids,
  })
}

const getArticleComments = (articleInfo) => {
  return http.get(api.getArticleComments(articleInfo), {
    headers: {
      'Content-Type': PROTOBUF_JSON,
      "Accept": "application/x-protobuf-json"
    },
  })
}

const getSecondComments = (commentInfo) => {
  return http.get(api.getArticleSecondComments(commentInfo), {
    headers: {
      'Content-Type': PROTOBUF_JSON,
      "Accept": "application/x-protobuf-json"
    },
  })
}
/**
 * 相关文章
 */
const getRelatedArticles = (id) => {
  return http.get(api.getReleteArtileAPI(id));
}

const replayComment = (info) => {
  return http.post(api.getReplayUrl(info), {
    content: info.content
  })
}

const likeComment = (info) => {
  return http.post(api.getLikeUrl(info), {}, {
    headers: {
      // 'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': PROTOBUF_JSON,
      "Accept": "application/x-protobuf-json"
    },
  })
}
const disLikeComment = (info) => {
  return http.delete(api.getLikeUrl(info), {}, {
    headers: {
      'Content-Type': PROTOBUF_JSON,
      "Accept": "application/x-protobuf-json"
    },
  })
}

const favorites = (articleId) => {
  return http.post(api.favorites, { articleId: articleId })
}

const alreadyFavorites = () => {
  return http.get(api.alreadyFavorites)
}

const shareArticle = () => {
  return http.get(api.shareUrl)
}

const newComerConfig = () => {
    return http.get(api.newComerConfigUrl)
}

export default {
  getBatchProductInfoByIds,
  getProductsByIds,
  getArticleDetail,
  getArticleComments,
  getRelatedArticles,
  replayComment,
  likeComment,
  disLikeComment,
  getSecondComments,
  favorites,
  alreadyFavorites,
  shareArticle,
  newComerConfig
}